import React from 'react';
import {inject, observer} from 'mobx-react';
import {toJS} from 'mobx';
import {Popover} from 'antd';
import {WeaIntro, WeaAvatar} from 'ecCom';
const {Step} = WeaIntro;

import E9AccountContent from '../E9AccountContent';

@inject('portalIntroStore')
@inject('portalThemeStore')
@observer
class IntroStep5 extends React.Component {
    constructor(props) {
        super(props);
        this.onVisibleChange = this.onVisibleChange.bind(this);
    }

    render() {
        const {portalThemeStore, portalIntroStore} = this.props;
        const {account, accountVisible, accountSize, accountList, accountMoreMenu} = portalThemeStore;
        const _account = toJS(account);
        const _accountList = toJS(accountList);
        const _accountMoreMenu = toJS(accountMoreMenu);
        const {intro_step} = portalIntroStore;

        let {icon, userid, username, showMore = false} = _account;
        icon = !icon ? '/messager/images/icon_m_wev8.jpg' : icon;

        if (showMore) {
            return (
                <Popover
                    trigger="click"
                    placement="bottomLeft"
                    content={<Step id={'portal-intro5'}><E9AccountContent account={_account} accountSize={accountSize} accountList={_accountList} accountMoreMenu={_accountMoreMenu} onVisibleChange={this.onVisibleChange}/></Step>}
                    overlayClassName="e9header-account-overlay"
                    visible={accountVisible}
                    onVisibleChange={this.onVisibleChange}
                    afterPopupVisibleChange={v => intro_step.intro5 && v && setTimeout(() => window.portal_intro.goToStep(5), 150)}
                >
                    <div>
                        <div className="e9header-account-img">
                            <WeaAvatar userId={userid}/>
                        </div>
                        <span className="e9header-account-username">{username}</span>
                        <span className="e9header-account-icon">
                            <i className="wevicon-account-arrow"/>
                        </span>
                    </div>
                </Popover>
            );
        } else {
            return (
                <div onClick={() => portalThemeStore.onLoadMain({mobxrouteurl: '/hrm/card/cardInfo'})}>
                    <div className="e9header-account-img">
                        <WeaAvatar userId={userid}/>
                    </div>
                    <span className="e9header-account-username">{username}</span>
                </div>
            );
        }
    }

    onVisibleChange(visible) {
        const {portalThemeStore, portalIntroStore} = this.props;
        const {intro_step} = portalIntroStore;
        !intro_step.intro6 && portalThemeStore.onAccountVisibleChange(visible);

        const themeLayoutMask = document.getElementById('themeLayoutMask');
        if (visible) {
            themeLayoutMask.style.display = 'block';
        } else {
            themeLayoutMask.style.display = 'none';
        }
    }
}

export default IntroStep5;


// WEBPACK FOOTER //
// ../src4js/pc4mobx/portal4theme/components/theme/ecology9/portalintro/IntroStep5.js